module.exports = __webpack_public_path__ + "img/daily_person.b62e5bdf.svg";